const enterKeyCode = 13
const tabKeyCode = 9

export const useCustomOnKeyDown = ({ setFocus }) => {
  const handleOnKeyDown = (event, nextField, customAction) => {
    if ([enterKeyCode, tabKeyCode].includes(event.keyCode) && !event.shiftKey) {
      event.preventDefault()
      setFocus(nextField)
      if (customAction) {
        customAction()
      }
    }
  }

  return {
    handleOnKeyDown
  }
}
